import styled from 'styled-components';

export const SingleProfessional = styled.div`
color: #110317;
font-family: "Questrial";
font-size: 1em;
line-height: 25px;
background-color: #A66AA1;
width: 90%;
border-radius: 3px;
padding: 15px 15px 15px 15px;
margin: auto;
margin-bottom: 40px;

@media (min-width: 1024px){
    width: 55%;
    padding: 25px 25px 25px 25px;
    font-size: 1.1rem;
    line-height: 30px;
}`

export const CategoryP = styled.span`
color: #1C0825;
font-family: "Questrial";
font-weight: bold;
font-size: 1em;

@media (min-width: 1024px){
    font-size: 1em;
    line-height: 30px;
}`

export const UserIcon = styled.i`
display: flex;
justify-content: center;`